function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter7219",
  x: -0.0061,
  y: -0.0059,
  width: 1.0121,
  height: 1.0119,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.0803
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7231",
  x: -0.006,
  y: -0.006,
  width: 1.0121,
  height: 1.0119,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1063
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19079-0-1-9-7-1-0",
  x: -0.0081,
  y: -0.0081,
  width: 1.0161,
  height: 1.0161,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2846
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19075-4-3-3-1-1-2",
  x: -0.0036,
  y: -0.0036,
  width: 1.0072,
  height: 1.0072,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2846
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5915-3-6",
  x: -0.0024,
  y: -0.0024,
  width: 1.0048,
  height: 1.0048,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1702
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2994-7-7",
  x: -0.0018,
  y: -10213,
  width: 1.0036,
  height: 20428,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1277
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5073",
  x: -0.006,
  y: -0.006,
  width: 1.012,
  height: 1.012,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2337
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5085",
  x: -0.012,
  y: -0.012,
  width: 1.024,
  height: 1.024,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2261
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14372-8",
  x: -0.0036,
  y: -0.0036,
  width: 1.0072,
  height: 1.0072,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2129
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1276",
  x: -0.03,
  y: -0.03,
  width: 1.06,
  height: 1.06,
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5095
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2859",
  x1: 508.33,
  x2: 448.55,
  y1: -219.47,
  y2: -279.5,
  gradientTransform: "translate(1992.2 47.865)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2251ee",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2861",
  x1: 1377.9,
  x2: 1462.4,
  y1: -473.45,
  y2: -473.45,
  gradientTransform: "rotate(-90 454.11 230.96) scale(.42487)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1890ff",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1890ff",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2863",
  x1: 1377.9,
  x2: 1462.4,
  y1: -473.45,
  y2: -473.45,
  gradientTransform: "rotate(-90 502.18 279.03) scale(.42487)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#737373",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#737373",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2865",
  x1: 1377.9,
  x2: 1462.4,
  y1: -473.45,
  y2: -473.45,
  gradientTransform: "rotate(-90 705.395 75.815) scale(.42487)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00f",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00f",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2867",
  x1: 1377.9,
  x2: 1462.4,
  y1: -473.45,
  y2: -473.45,
  gradientTransform: "rotate(-90 657.325 27.745) scale(.42487)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#b3b3b3",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#b3b3b3",
  offset: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -0.0008,
  y: -0.0001,
  width: 450.43,
  height: 236.57,
  ry: 0,
  fill: "#fff",
  fillOpacity: 0.0018
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "analytic-toolkit-border",
  d: "M22.003 195.77v-35.881",
  fill: "none",
  opacity: 0.99,
  stroke: "url(#linearGradient2863)",
  strokeWidth: 0.8294
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "dial-circle-filled",
  cx: 225.21,
  cy: 129.84,
  r: 74.153,
  opacity: 0.367,
  strokeWidth: 1.0449,
  paintOrder: "normal"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.3185
}, /*#__PURE__*/React.createElement("path", {
  transform: "scale(.868) rotate(45 347.8683 -1357.94)",
  d: "M1291.3-289.54l120.37 120.37",
  filter: "url(#filter5915-3-6)"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(-1945.9 278.85) scale(.86805)",
  d: "M2415.8-171.45h170.22",
  filter: "url(#filter2994-7-7)"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(-1945.9 278.85) scale(.86805)",
  d: "M2440.8-231.64l120.37 120.37",
  filter: "url(#filter5915-3-6)"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-1948.1 278.69) scale(.86907)",
  d: "M2561.1-231.64l-120.37 120.37",
  fill: "url(#linearGradient2859)",
  filter: "url(#filter5915-3-6)",
  stroke: "#333",
  strokeWidth: 0.3159
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(39.019 -200.43) scale(.74831)",
  cx: 248.82,
  cy: 441.36,
  r: 100.38,
  fill: "none",
  filter: "url(#filter1276)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.2168
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-164.1794 -1201.692 142.086) scale(1.04488)",
  cx: -2460.7,
  cy: 519.45,
  r: 22.61,
  fill: "none",
  filter: "url(#filter5085)",
  stroke: "#4d4d4d",
  strokeWidth: 0.3969
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449,
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(172.13)",
  cx: -205.66,
  cy: -157.86,
  rx: 36.924,
  ry: 36.447
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(187.75)",
  cx: -240.42,
  cy: -97.131,
  r: 69.066
}), /*#__PURE__*/React.createElement("rect", {
  x: 276.9,
  y: 123.09,
  width: 21.201,
  height: 11.489,
  ry: 0.718
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.44,
  cy: 123.05,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295.35,
  cy: 123.09,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 211.28,
  y: 185.94,
  width: 27.692,
  height: 13.275,
  ry: 0.8297
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 229.69,
  cy: 185.78,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.6,
  cy: 185.82,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 179.57,
  y: 122.69,
  width: 21.12,
  height: 12.282,
  ry: 0.7676
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 191.49,
  cy: 122.58,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 198.4,
  cy: 122.62,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 211.46,
  y: 62.322,
  width: 27.751,
  height: 12.644,
  ry: 0.7902
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.01,
  cy: 62.332,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.91,
  cy: 62.384,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 249.62,
  y: 122.86,
  width: 20.972,
  height: 12.282,
  ry: 0.7676
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.4,
  cy: 122.75,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 268.3,
  cy: 122.79,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 212.89,
  y: 89.552,
  width: 24.222,
  height: 13.051,
  ry: 0.8157
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 227.73,
  cy: 89.5,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.64,
  cy: 89.542,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 204.33,
  cy: 83.847,
  rx: 0.9437,
  ry: 1.0111
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449,
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 165.71,
  y: 167.67,
  width: 26.424,
  height: 7.4284,
  ry: 0.4643
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 183.05,
  cy: 167.75,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 189.96,
  cy: 167.8,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 152.55,
  y: 122.98,
  width: 21.201,
  height: 12.052,
  ry: 0.7533
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 164.41,
  cy: 122.96,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 213.15,
  y: 158.37,
  width: 24.222,
  height: 12.577,
  ry: 0.786
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 227.9,
  cy: 158.37,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.8,
  cy: 158.41,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 231.97,
  cy: 123.33,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.25,
  cy: 123.33,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.56,
  cy: 123.36,
  rx: 0.9437,
  ry: 1.0111
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449,
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 253.33,
  y: 167.39,
  width: 26.096,
  height: 11.282,
  ry: 0.7051
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 270.13,
  cy: 167.31,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 277.04,
  cy: 167.35,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 258.13,
  y: 83.011,
  width: 20.749,
  height: 6.8692,
  ry: 0.4293
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 269.45,
  cy: 82.896,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.35,
  cy: 82.938,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 169.94,
  y: 83.826,
  width: 20.749,
  height: 6.8796,
  ry: 0.43
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(172.13)",
  cx: -205.66,
  cy: -157.86,
  rx: 36.924,
  ry: 36.447
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(187.75)",
  cx: -240.42,
  cy: -97.131,
  r: 69.066
}), /*#__PURE__*/React.createElement("rect", {
  x: 276.9,
  y: 123.09,
  width: 21.201,
  height: 11.489,
  ry: 0.718
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.44,
  cy: 123.05,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295.35,
  cy: 123.09,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 211.28,
  y: 185.94,
  width: 27.692,
  height: 13.275,
  ry: 0.8297
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 229.69,
  cy: 185.78,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.6,
  cy: 185.82,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 179.57,
  y: 122.69,
  width: 21.12,
  height: 12.282,
  ry: 0.7676
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 191.49,
  cy: 122.58,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 198.4,
  cy: 122.62,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 211.46,
  y: 62.322,
  width: 27.751,
  height: 12.644,
  ry: 0.7902
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.01,
  cy: 62.332,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.91,
  cy: 62.384,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 249.62,
  y: 122.86,
  width: 20.972,
  height: 12.282,
  ry: 0.7676
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.4,
  cy: 122.75,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 268.3,
  cy: 122.79,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("rect", {
  x: 212.89,
  y: 89.552,
  width: 24.222,
  height: 13.051,
  ry: 0.8157
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 227.73,
  cy: 89.5,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.64,
  cy: 89.542,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 204.33,
  cy: 83.847,
  rx: 0.9437,
  ry: 1.0111
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("rect", {
  x: 165.71,
  y: 167.67,
  width: 26.424,
  height: 7.4284,
  ry: 0.4643,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 183.05,
  cy: 167.75,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 189.96,
  cy: 167.8,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 152.55,
  y: 122.98,
  width: 21.201,
  height: 12.052,
  ry: 0.7533,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 164.41,
  cy: 122.96,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 213.15,
  y: 158.37,
  width: 24.222,
  height: 12.577,
  ry: 0.786,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 227.9,
  cy: 158.37,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.31,
  cy: 159.61,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 232.82,
  cy: 159.61,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.8,
  cy: 158.41,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 231.97,
  cy: 123.33,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.25,
  cy: 123.33,
  rx: 0.9437,
  ry: 1.0111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.56,
  cy: 123.36,
  rx: 0.9437,
  ry: 1.0111
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("rect", {
  x: 253.33,
  y: 167.39,
  width: 26.096,
  height: 11.282,
  ry: 0.7051,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 270.13,
  cy: 167.31,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 271.36,
  cy: 168.26,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 273.86,
  cy: 168.26,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 277.04,
  cy: 167.35,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 258.13,
  y: 83.011,
  width: 20.749,
  height: 6.8692,
  ry: 0.4293,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 269.45,
  cy: 82.896,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 276.35,
  cy: 82.938,
  rx: 0.9437,
  ry: 1.0111,
  fill: "none"
}));

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 184.5,
  cy: 168.24,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 186.99,
  cy: 168.24,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
});

var _ref21 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.66,
  cy: 187.2,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.16,
  cy: 187.2,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  fill: "#666",
  strokeWidth: 0.2646
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(21.158 34.742) scale(1.0449)",
  d: "M162.25 89.034q.4494-.015.8952.183.4457.1923.7627.5595.344.4025.5477.9491.2037.5415.2288 1.3162.0269.8316-.1065 1.5029-.1335.6661-.416 1.3629l-1.2809.042-.002-.072q.4666-.5994.7053-1.3723t.2169-1.4444q-.0308-.9503-.4042-1.4656-.3736-.5205-.9676-.5012-.5113.016-.7459.2775-.2347.2557-.3524.7714-.0908.3907-.1432.8474-.0526.4515-.1395.961-.1838 1.0297-.6894 1.5425-.511.5077-1.3528.5349-.9659.031-1.607-.7648-.6462-.796-.6868-2.0511-.0263-.8109.1068-1.4925.133-.6817.3434-1.2107l1.2086-.039.002.072q-.3577.4511-.5772 1.1768-.2248.7208-.2006 1.4698.0266.8212.3837 1.3111.357.4848.8941.4674.4804-.016.746-.2723.2658-.2568.3902-.8864.0616-.3329.1451-.9457.0836-.6128.1784-1.0399.1994-.8647.645-1.3134.4457-.4488 1.272-.4755zM165.12 84.434q.0295.2817.0256.6106-.003.3237-.0419.5739-.1353.8733-.6756 1.255-.5402.3816-1.5769.221l-3.0334-.4701-.1005.6486-.8068-.1251.1005-.6485-1.6392-.254.1488-.9601 1.6392.254.307-1.9814.8069.1251-.307 1.9814 2.5992.4028q.4494.07.7079.089.2534.018.492-.07.2217-.081.3487-.2597.1228-.185.1854-.5884.0364-.2349.01-.5005-.032-.2664-.0605-.3859l.008-.051zM162 78.534l-.0149.049q-.1122.1929-.1917.3848-.083.1855-.1636.4526-.1298.4304-.0579.8894.0671.4575.257.9196l3.9231 1.1839-.2807.9301-5.526-1.6676.2806-.9301.8163.2463q-.278-.6885-.3342-1.1642-.0596-.4822.0733-.9225.0732-.2424.1209-.3468.0427-.1059.143-.3131zM168.83 75.134l-.4353.8628-.549-.277q.0202.1549.0632.4255.0406.2636.0306.49-.003.2704-.0761.5868-.0682.3187-.259.697-.3515.6967-1.0572.9483-.7058.2517-1.421-.1091-.5859-.2956-.82-.7263-.2365-.4376-.209-1.0083.0297-.5754.2888-1.2724t.6038-1.4723l-.1338-.067q-.2953-.1489-.5426-.1406-.245 0-.4534.1417-.1993.131-.3665.3707-.1673.2398-.3093.5212-.1722.3414-.2917.8079-.1242.464-.1793.9977l-.0233.046-.8812-.4446q.0588-.2886.2179-.8104.159-.5217.394-.9877.2747-.5444.5695-.8992.2925-.3618.6583-.5477.3589-.1836.7725-.1659.4136.018.9119.269zm-1.704.2227l-1.4349-.7239q-.1771.4085-.4033.9715-.2239.5585-.2945.9165-.0824.4272.0273.772.1051.3424.4973.5402.4429.2235.804.07.3564-.1558.6334-.7049.2305-.4567.246-.9235.0109-.4691-.0753-.9178zM171.64 71.134q-.105.2631-.2614.5524-.1534.2851-.3042.4885-.5262.71-1.182.7964-.6558.086-1.4986-.5382l-2.4662-1.8277-.3908.5273-.656-.4862.3908-.5272-1.3327-.9877.5785-.7806 1.3327.9877 1.1938-1.6109.656.4862-1.1939 1.6109 2.1132 1.5661q.3654.2708.5853.408.2157.1342.4681.1669.2338.032.4296-.068.1947-.1065.4378-.4345.1415-.191.2414-.4386.0957-.2507.126-.3697l.0308-.042zM174.01 64.934l-3.0726 2.9406q.368.3846.7589.5613.3873.1729.764.1629.3656-.01.7164-.1706.3546-.1677.6756-.475.4256-.4073.6942-.9862.2687-.5862.2944-.9256l.0373-.036.7325.7654q-.2117.4887-.4849.9433-.2731.4545-.68.8439-1.038.9933-2.1562.9907-1.122-.01-2.1117-1.0405-.979-1.0229-.998-2.1563-.0153-1.1371.8956-2.0089.8438-.8075 1.7708-.7506.9309.053 1.7991.9605zm-1.1977.1163q-.5325-.549-1.0982-.587-.562-.042-1.122.4944-.5637.5395-.5817 1.1934-.0143.6502.4125 1.1859zM180.77 63.034q.7714 1.2486.5655 2.1837-.2058.935-1.384 1.663-.3912.2417-.8002.4155-.4019.1754-.8248.297l-.5215-.8441.044-.027q.251-.046.7613-.2032.513-.1529.9526-.4245.422-.2608.6365-.533.2145-.2723.257-.5476.048-.2665-.0355-.549-.0834-.2826-.2681-.5815l-.2771-.4484q-.189.5298-.4395.8911-.2489.3543-.7764.6802-.8793.5433-1.7891.2307-.9082-.3196-1.6226-1.4758-.3912-.6331-.4978-1.1989-.105-.573-.004-1.0973.0929-.4886.3958-.9127.3002-.4285.7046-.6784.4265-.2634.7666-.3521.3417-.096.7713-.1181l-.0776-.2436.7737-.4781zm-1.3154-.2806l-1.6542-2.6773q-.422.054-.7459.1692-.322.1079-.6034.2818-.6814.421-.7902 1.1199-.1088.699.429 1.5694.5107.8265 1.0643 1.0737.5537.2471 1.2262-.1684.3605-.2228.6368-.5818.278-.3661.4374-.7865zM181.24 56.234l-1.01.4244-.3904-.929 1.01-.4244zm2.5533 6.2365l-.8956.3763-2.2361-5.3215.8956-.3764zM189.62 60.334q-.4095.3498-.8007.5877-.3862.2366-.8606.363-.6042.161-1.155.1206-.5523-.045-1.0077-.3092-.4603-.2624-.8063-.7584-.3461-.4961-.5417-1.2301-.3645-1.3682.177-2.3468.5464-.9798 1.7797-1.3085.4794-.1277.9747-.1153.5003.011.9367.1034l.278 1.0437-.0498.013q-.5186-.2202-1.026-.2775-.5022-.059-.9367.057-.799.2129-1.1197.8759-.317.6567-.0403 1.6953.2688 1.0087.8632 1.4333.598.4182 1.417.2.2846-.076.5593-.2292.2746-.1534.4774-.3358.1768-.1594.326-.3222.1478-.1677.23-.2805l.05-.013zM195.44 60.134l-.964.067-.0425-.6134q-.1229.097-.3335.2717-.2058.1696-.4056.2767-.234.1353-.5432.2344-.3088.1043-.7315.1335-.7784.054-1.3554-.4242-.577-.478-.6323-1.2771-.0453-.6547.2053-1.0761.2553-.4269.76-.6949.5097-.2684 1.2412-.4019t1.5741-.2333l-.0104-.1495q-.0228-.3299-.1564-.5382-.1284-.2087-.3534-.3175-.2144-.1043-.506-.1255-.2916-.021-.606.0005-.3815.026-.8435.162-.4624.1304-.9492.3557h-.0516l-.0681-.9847q.2782-.097.8079-.2268.5297-.1299 1.0504-.166.6083-.042 1.064.03.4604.067.8071.286.3412.2147.5374.5793.1962.3645.2347.9213zm-1.0622-1.351l-.111-1.6033q-.4415.056-1.0412.1498-.5944.093-.9382.2151-.4094.1475-.6496.418-.2407.2652-.2104.7035.0343.4949.3508.7268.3161.2267.9296.1843.5104-.035.9195-.2605.4089-.2303.7505-.5337zM198.3 60.434l-.9683-.079.6565-8.014.9683.079z",
  filter: "url(#filter7231)"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  fill: "#666",
  strokeWidth: 0.2646
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(21.158 34.742) scale(1.0449)",
  d: "M140.94 62.334l-1.1277 2.5073 6.188 2.7833-.4197.9331-6.188-2.7833-1.1278 2.5073-.8295-.3731 2.6752-5.9476zM149.34 61.434l-.4877.8342-.5309-.3103q.0106.1558.0368.4285.0243.2656.0003.491-.02.2697-.1122.5809-.0877.3139-.3016.6797-.3938.6737-1.1138.8813t-1.4114-.1967q-.5665-.3312-.7737-.7756-.209-.4514-.1463-1.0193.0653-.5724.3669-1.2521t.6936-1.4322l-.1294-.076q-.2855-.1669-.5328-.1739-.2448-.011-.4614.1134-.207.1185-.3887.3474-.1817.229-.3408.5011-.193.3301-.3411.7883-.1526.4555-.2405.9847l-.0261.045-.8521-.4981q.0765-.2845.2675-.7954.1909-.5109.4543-.9615.3078-.5264.624-.8624.3142-.343.6908-.5059.3695-.1611.7813-.1179.4117.043.8935.3248zm-1.7145.117l-1.3874-.8111q-.202.3967-.4625.9447-.258.5436-.3506.8965-.1086.4213-.0205.7722.0837.3482.463.5699.4283.2504.7981.1195.3654-.1336.6758-.6645.2582-.4416.3026-.9066.0399-.4675-.0184-.9206zM152.66 56.234q-.1028.5286-.2608.9583-.155.4256-.4476.8198-.3727.5021-.829.8134-.4604.3082-.981.3853-.5235.081-1.1031-.092-.5797-.1728-1.1896-.6255-1.137-.8439-1.3223-1.9468-.1823-1.1071.5784-2.132.2957-.3984.691-.697.3985-.3027.7975-.5021l.8673.6437-.0308.042q-.543.1505-.9757.4214-.4296.2667-.6975.6277-.4928.6639-.3311 1.3825.1606.7113 1.0238 1.3519.8382.6221 1.5677.5844.7284-.045 1.2335-.7255.1755-.2366.295-.5276t.1646-.5599q.0391-.2349.0546-.4551.0113-.2233.005-.3628l.0308-.041zM155.74 53.234q-.1282.2526-.3101.5266-.1785.2701-.347.4591-.588.6597-1.2489.6867t-1.444-.6711l-2.2914-2.0424-.4367.4899-.6095-.5433.4367-.4899-1.2383-1.1038.6464-.7252 1.2383 1.1038 1.3341-1.4968.6095.5433-1.334 1.4967 1.9634 1.7502q.3395.3026.5462.4591.2027.1531.4511.2083.23.053.434-.028.2035-.089.4751-.3934.1582-.1774.28-.415.1179-.241.1588-.3568l.0344-.039zM152.64 46.934l-.7809.7684-.7068-.7182.7809-.7685zm4.6824 4.8464l-.6925.6814-4.0488-4.1141.6925-.6815zM161.75 47.434q-.2218.4908-.4746.8725-.2489.3784-.6244.6946-.4783.4028-.994.6006-.5191.1938-1.0434.1489-.5282-.042-1.0525-.3434-.5242-.3017-1.0135-.8828-.912-1.0831-.8382-2.199.0777-1.1193 1.0541-1.9414.3795-.3195.833-.519.4575-.2028.8917-.3049l.6957.8262-.0395.033q-.563.021-1.0465.1853-.4796.1606-.8235.4502-.6325.5325-.6407 1.269-.008.7292.6848 1.5514.6723.7985 1.3909.9298.7192.1241 1.3675-.4218.2253-.1897.4086-.4454.1833-.2556.2892-.5069.0922-.2195.158-.4303.0624-.2147.0889-.3518l.0395-.033zM166.72 44.434l-.8025.5384-.3426-.5107q-.0583.1449-.1536.4018-.0939.2496-.2137.442-.1355.2341-.354.474-.2158.2443-.5677.4804-.648.4347-1.3865.3079-.7385-.1268-1.1848-.792-.3656-.545-.3584-1.0352.009-.4973.3124-.9812.3082-.4868.8758-.9672.5676-.4803 1.2483-.9868l-.0835-.1245q-.1843-.2746-.404-.3886-.2152-.1169-.4646-.099-.2378.017-.5012.1433-.2633.1269-.5251.3026-.3176.213-.6505.5608-.3358.3436-.6455.7816l-.043.029-.5498-.8196q.1928-.2228.5873-.5994.3944-.3767.8279-.6675.5063-.3397.9373-.5044.4323-.1718.8423-.1543.4028.016.7546.2342.3517.2183.6627.6818zm-1.5942-.6417l-.8954-1.3346q-.3546.269-.828.6488-.469.3769-.706.6542-.2814.3319-.355.6861-.0763.3499.1684.7147.2764.412.6664.4553.387.039.8977-.3036.4249-.2851.6674-.6842.2396-.4035.3845-.8367zM169.22 43.034l-.8497.471-3.8986-7.0324.8497-.4711z",
  filter: "url(#filter7219)"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("rect", {
  x: 169.94,
  y: 83.826,
  width: 20.749,
  height: 6.8796,
  ry: 0.43,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 264.59,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 267.09,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 287.7,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 290.19,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}));

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 188.73,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 191.24,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 182.81,
  cy: 83.078,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 185.29,
  cy: 83.078,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 187.8,
  cy: 83.078,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#00f"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.16,
  cy: 120.97,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#1890ff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.17,
  cy: 89.165,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 230.67,
  cy: 89.165,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.0449
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 168.72,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 166.23,
  cy: 124.39,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 274.85,
  cy: 83.024,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 277.35,
  cy: 83.024,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 232.32,
  cy: 63.826,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#737373"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 234.82,
  cy: 63.826,
  rx: 0.9437,
  ry: 1.0111,
  fill: "#b3b3b3"
}));

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(21.158 34.742) scale(1.0449)",
  cx: 195.28,
  cy: 91.014,
  r: 70.965,
  fill: "none",
  filter: "url(#filter14372-8)",
  stroke: "gray",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.9261
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(21.158 34.742) scale(1.0449)",
  cx: 195.28,
  cy: 91.014,
  r: 46.731,
  fill: "none",
  filter: "url(#filter5073)",
  stroke: "#4d4d4d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.3969
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "market-views-border",
  d: "M22.003 99.639V63.758",
  fill: "none",
  opacity: 0.99,
  stroke: "url(#linearGradient2861)",
  strokeWidth: 0.8294
});

var _ref33 = /*#__PURE__*/React.createElement("tspan", {
  x: 420.0264,
  y: 78.5384
}, "The stuff we know");

var _ref34 = /*#__PURE__*/React.createElement("tspan", {
  x: 421.2158,
  y: 91.4403
}, "Grow your knowledge ");

var _ref35 = /*#__PURE__*/React.createElement("tspan", {
  x: 420.0264,
  y: 97.8912
}, "and learn from and with us");

var _ref36 = /*#__PURE__*/React.createElement("path", {
  id: "education-border",
  d: "M428.43 99.639V63.758",
  fill: "none",
  stroke: "url(#linearGradient2867)",
  strokeWidth: 0.8294
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  id: "education-container",
  d: "M428.36 59.704c.2453 0 .4428.0893.4428.2004v43.829c0 .111-.1975.2003-.4428.2003h-73.856a111.69 93.612 0 00-29.958-44.23z",
  fillOpacity: 0,
  paintOrder: "normal"
});

var _ref38 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.2354,
  y: 78.5384
}, "Follow our professional view");

var _ref39 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.2354,
  y: 91.4404
}, "Financial markets, currencies,");

var _ref40 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.2354,
  y: 97.8914
}, "commodities and everything moving");

var _ref41 = /*#__PURE__*/React.createElement("path", {
  id: "market-views-container",
  d: "M22.201 62.13c-.331 0-.5975.0844-.5975.1894v41.426c0 .105.2665.1894.5975.1894h99.656c6.6446-15.858 20.635-30.327 40.423-41.805-47.024 0-140.08.0003-140.08.0003z",
  fillOpacity: 0,
  paintOrder: "normal"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  id: "community-border",
  d: "M428.43 195.77v-35.881",
  fill: "none",
  stroke: "url(#linearGradient2865)",
  strokeWidth: 0.8294
});

var _ref43 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.3387,
  y: 174.796
}, "The stuff we use");

var _ref44 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.3387,
  y: 187.698
}, "Professional tools");

var _ref45 = /*#__PURE__*/React.createElement("tspan", {
  x: 30.3387,
  y: 194.149
}, "explained and ready for you to use");

var _ref46 = /*#__PURE__*/React.createElement("path", {
  id: "analytic-toolkit-container",
  d: "M22.045 155.22c-.2323 0-.4197.0914-.4197.2054v44.98c0 .114.1874.2059.4197.2059h108.16a115.26 96.737 0 01-31.575-45.391z",
  fillOpacity: 0,
  paintOrder: "normal"
});

var _ref47 = /*#__PURE__*/React.createElement("tspan", {
  x: 420.0264,
  y: 174.5897
}, "Follow fellow investors");

var _ref48 = /*#__PURE__*/React.createElement("tspan", {
  x: 420.0264,
  y: 187.4917
}, "Enjoy live webinars and connect");

var _ref49 = /*#__PURE__*/React.createElement("tspan", {
  x: 420.0264,
  y: 193.9427
}, "with like-minded market enthusiasts");

var _ref50 = /*#__PURE__*/React.createElement("path", {
  id: "community-container",
  d: "M354.47 152.84a111.71 100.48 0 01-30.759 47.933h104.57c.2749 0 .4967-.0967.4967-.2171v-47.5c0-.1204-.2218-.2167-.4967-.2167z",
  fillOpacity: 0,
  paintOrder: "normal"
});

var SvgFrontendElementDialWings4Conv = function SvgFrontendElementDialWings4Conv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1702.4,
    height: 894.11,
    viewBox: "0 0 450.43 236.57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("text", {
    id: "analytic-toolkit-title",
    x: 30.156,
    y: 166.0329,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 7.5576,
    fontWeight: 600,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.156,
    y: 166.0329,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Analytic Toolkit")), _ref4, /*#__PURE__*/React.createElement("text", {
    id: "community-title",
    x: 379.5608,
    y: 166.0027,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 7.5576,
    fontWeight: 600,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 379.5608,
    y: 166.0027,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Community")), _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("path", {
    transform: "translate(131.84 -36.837) scale(.24994)",
    d: "M331.44 624.51l31.262 42.37-.0004.0003-31.261 42.371 42.371-31.261 42.371 31.261-31.261-42.371 31.262-42.371-42.371 31.262z",
    color: "#000",
    fill: "#333",
    filter: "url(#filter19079-0-1-9-7-1-0)",
    opacity: 0.448,
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(131.84 -36.838) scale(.24994)",
    d: "M373.81 572l-12.438 82.444h-.0008l-82.444 12.439 82.444 12.439 12.439 82.444 12.439-82.444 82.445-12.439-82.445-12.439z",
    color: "#000",
    fill: "#333",
    filter: "url(#filter19075-4-3-3-1-1-2)",
    opacity: 0.448,
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-market-views",
    x: 216.7073,
    y: 127.9132,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2885,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 216.7073,
    y: 127.9132,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Market "), /*#__PURE__*/React.createElement("tspan", {
    x: 216.7073,
    y: 134.825,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Views")), _ref18, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-anomalies",
    x: 212.0577,
    y: 70.9379,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 212.0577,
    y: 70.9379,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Anomalies")), /*#__PURE__*/React.createElement("text", {
    id: "dial-text-volatility",
    x: 258.0899,
    y: 90.0932,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 258.0899,
    y: 90.0932,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Volatility")), /*#__PURE__*/React.createElement("text", {
    id: "dial-text-flows",
    x: 279.917,
    y: 131.369,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 279.917,
    y: 131.369,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Flows")), /*#__PURE__*/React.createElement("text", {
    id: "dial-text-gamma",
    x: 258.5639,
    y: 175.2063,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 258.5639,
    y: 175.2063,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Gamma")), /*#__PURE__*/React.createElement("text", {
    id: "dial-text-sectors",
    x: 252.2587,
    y: 131.3138,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 252.2587,
    y: 131.3138,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Sectors"))), _ref19, _ref20, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-spreads",
    x: 170.3525,
    y: 175.1972,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 170.3525,
    y: 175.1972,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Spreads")), _ref21, _ref22, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-seasonality",
    x: 210.7331,
    y: 194.1878,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 210.7331,
    y: 194.1878,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Seasonality")), _ref23, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-calendar",
    x: 214.0498,
    y: 166.6118,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 214.0498,
    y: 166.6118,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Calendar")), _ref24, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-economy",
    x: 213.5991,
    y: 96.1361,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 213.5991,
    y: 96.1361,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Economy")), _ref25, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-cot",
    x: 184.468,
    y: 131.3138,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 184.468,
    y: 131.3138,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "COT")), _ref26, _ref27, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-portfolio",
    x: 169.7947,
    y: 90.1018,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 169.7947,
    y: 90.1018,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Portfolio")), _ref28, /*#__PURE__*/React.createElement("text", {
    id: "dial-text-timing",
    x: 155.2268,
    y: 131.4047,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 5.5294,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 155.2268,
    y: 131.4047,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Timing")), _ref29, _ref30, _ref31, /*#__PURE__*/React.createElement("text", {
    id: "market-views-title",
    x: 30.0048,
    y: 69.9193,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 7.5576,
    fontWeight: 600,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.0048,
    y: 69.9193,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Market Views")), _ref32, /*#__PURE__*/React.createElement("text", {
    id: "education-title",
    x: 385.1302,
    y: 69.9193,
    fill: "#fff",
    fontFamily: "Kanit",
    fontSize: 7.5576,
    fontWeight: 600,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 385.1302,
    y: 69.9193,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Education")), /*#__PURE__*/React.createElement("text", {
    id: "education-text",
    x: 420.0264,
    y: 78.5384,
    fill: "#eee",
    fontFamily: "Kanit",
    fontSize: 5.1608,
    fontWeight: 300,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    textAnchor: "end",
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _ref33, _ref34, _ref35), _ref36, _ref37, /*#__PURE__*/React.createElement("text", {
    id: "market-views-text",
    x: 30.2354,
    y: 78.5384,
    fill: "#eee",
    fontFamily: "Kanit",
    fontSize: 5.1608,
    fontWeight: 300,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _ref38, _ref39, _ref40), _ref41, _ref42, /*#__PURE__*/React.createElement("text", {
    id: "analytic-toolkit-text",
    x: 30.3387,
    y: 174.796,
    fill: "#eee",
    fontFamily: "Kanit",
    fontSize: 5.1608,
    fontWeight: 300,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _ref43, _ref44, _ref45), _ref46, /*#__PURE__*/React.createElement("text", {
    id: "community-text",
    x: 420.0264,
    y: 174.5897,
    fill: "#eee",
    fontFamily: "Kanit",
    fontSize: 5.1608,
    fontWeight: 300,
    letterSpacing: 0,
    strokeWidth: 0.2765,
    textAnchor: "end",
    wordSpacing: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _ref47, _ref48, _ref49), _ref50);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFrontendElementDialWings4Conv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/frontend-element_dial-wings_4_conv.b6ceefb5.svg";
export { ForwardRef as ReactComponent };